const DEFAULT_PANEL_PADDING_X = { xs: 1.2, sm: 2.2, md: 4 };
const DENSE_PANEL_PADDING_X = { xs: 0.5, sm: 1.4, md: 3 };

function boardWidthFormula(viewportOffsetPx, boardMaxWidthPx, columns, rows) {
  return `min(calc(100vw - ${viewportOffsetPx}px), ${boardMaxWidthPx}px, calc(min(67dvh, 520px) * ${columns} / ${rows}))`;
}

const MEMORY_LAYOUTS = {
  2: {
    columns: 2,
    rows: 2,
    boardMaxWidth: 520,
    boardWidth: boardWidthFormula(44, 520, 2, 2),
    gap: { xs: '7px', sm: '10px', md: '13px' },
    panelWidthXs: 'calc(100vw - 20px)',
    panelPaddingX: DEFAULT_PANEL_PADDING_X,
  },
  3: {
    columns: 3,
    rows: 2,
    boardMaxWidth: 760,
    boardWidth: boardWidthFormula(44, 760, 3, 2),
    gap: { xs: '7px', sm: '10px', md: '13px' },
    panelWidthXs: 'calc(100vw - 20px)',
    panelPaddingX: DEFAULT_PANEL_PADDING_X,
  },
  4: {
    columns: 4,
    rows: 2,
    boardMaxWidth: 760,
    boardWidth: boardWidthFormula(44, 760, 4, 2),
    gap: { xs: '7px', sm: '10px', md: '13px' },
    panelWidthXs: 'calc(100vw - 20px)',
    panelPaddingX: DEFAULT_PANEL_PADDING_X,
  },
  6: {
    columns: 4,
    rows: 3,
    boardMaxWidth: 650,
    boardWidth: boardWidthFormula(44, 650, 4, 3),
    gap: { xs: '7px', sm: '10px', md: '13px' },
    panelWidthXs: 'calc(100vw - 20px)',
    panelPaddingX: DEFAULT_PANEL_PADDING_X,
  },
  8: {
    columns: 4,
    rows: 4,
    boardMaxWidth: 590,
    boardWidth: boardWidthFormula(44, 590, 4, 4),
    gap: { xs: '7px', sm: '10px', md: '13px' },
    panelWidthXs: 'calc(100vw - 20px)',
    panelPaddingX: DEFAULT_PANEL_PADDING_X,
  },
  10: {
    columns: 5,
    rows: 4,
    boardMaxWidth: 576,
    boardWidth: boardWidthFormula(16, 576, 5, 4),
    gap: { xs: '4px', sm: '6px', md: '8px' },
    panelWidthXs: 'calc(100vw - 8px)',
    panelPaddingX: DENSE_PANEL_PADDING_X,
  },
  12: {
    columns: 4,
    rows: 6,
    boardMaxWidth: 360,
    boardWidth: boardWidthFormula(16, 360, 4, 6),
    gap: { xs: '4px', sm: '5px', md: '6px' },
    panelWidthXs: 'calc(100vw - 8px)',
    panelPaddingX: DENSE_PANEL_PADDING_X,
  },
};

export function getMemoryLayout(pairCount) {
  return MEMORY_LAYOUTS[Number(pairCount)] || MEMORY_LAYOUTS[8];
}